import { useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Close, MenuBook } from '@mui/icons-material';
import { CERCHAR_CLASSIFICATION_GUIDE_ROWS } from '../rockCercharFields';

const headSx = { py: 0.5, px: 1.5, fontSize: '0.74rem', fontWeight: 700, color: 'text.secondary' } as const;
const cellSx = { py: 0.5, px: 1.5, fontSize: '0.78rem' } as const;

/**
 * CAI Classification Guide popup (REQ-05). A "View Classification Guide" button
 * opening a MUI dialog that renders the interim CERCHAR classification bands
 * (range + abrasivity label) from rockCercharFields.ts.
 *
 * Re-added per BUG-2026-0142 rework (SHegger, 2026-07-16): it sits on the Result
 * Entry tab beside the "CAI Classification" result. (It had been removed with
 * the batch header in the v1.0.27 slim-down.)
 */
export const CaiClassificationGuide = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        size="small"
        variant="outlined"
        startIcon={<MenuBook sx={{ fontSize: 16 }} />}
        onClick={() => setOpen(true)}
        sx={{ fontSize: '0.74rem', textTransform: 'none' }}
      >
        View Classification Guide
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ fontSize: '0.95rem', fontWeight: 700, pr: 6 }}>
          CAI Classification Guide (Table 1)
          <IconButton
            size="small"
            onClick={() => setOpen(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <Close fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={headSx}>CAI (unitless)</TableCell>
                <TableCell sx={headSx}>Abrasivity</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {CERCHAR_CLASSIFICATION_GUIDE_ROWS.map((row) => (
                <TableRow key={row.label}>
                  <TableCell sx={cellSx}>{row.range}</TableCell>
                  <TableCell sx={cellSx}>{row.label}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.66rem', display: 'block', mt: 1.5 }}>
            Interim CERCHAR ranges (0.3–7.0 scale) pending lab confirmation of the exact
            classification labels and boundaries (D6 / R2).
          </Typography>
        </DialogContent>
      </Dialog>
    </>
  );
};
